<template>
  <v-chip
    :color="getStatus.color"
    :text-color="getStatus.textColor"
    class="text-uppercase"
    label
    :disabled="disabled"
  >
    {{ getStatus.text }}
  </v-chip>
</template>

<script>
import communicationStatus from './communicationStatus';

export default {
  name: 'CommunicationStatusColumn',
  props: {
    value: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      status: communicationStatus,
    };
  },
  computed: {
    getValue() {
      return this.value;
    },
    getStatus() {
      const value = this.getValue;
      const faultStatus = {
        text: 'Não identificado',
        value: '',
        color: '#ECEFF1',
        textColor: '#78909C',
      };

      if (!value) {
        return faultStatus;
      }

      const item = this.status.find(
        status => status.value === value,
      );

      if (!item) {
        return faultStatus;
      }

      return item;
    },
  },
};
</script>
